import Base64 from "crypto-js/enc-base64";
import HmacSHA256 from 'crypto-js/hmac-sha256';

let Client_id;
let secret_key;

let generate = (legacy, credentials, host) => {

    const hostLocal = typeof window !== 'undefined' ? window.location.host.toLowerCase() : host;

    if (hostLocal.includes('qa.webmd.com') || hostLocal.includes('staging')
        || hostLocal.includes('preview.webmd.com') || hostLocal.includes('localhost')) {
        Client_id = '414a9d52-a427-48a1-99bd-78ed7afa9996';
        secret_key = 'ca7fed5b-7b54-4e34-8d98-ab2579eed686'; // Non Prod
    } else {
        Client_id = '414a9d52-a427-48a1-99bd-78ed7afa9996'
        secret_key = '6a145282-d644-49ac-ac05-c85d26862e24'; // live
    }

    const currentTime = new Date();
    const Timestamp = (currentTime.getTime() - currentTime.getMilliseconds()) / 1000;
    const stringToSign = legacy ? `{timestamp:${Timestamp},client_id:${Client_id.toLowerCase()}}` :
        `{{timestamp:${Timestamp},client_id:${Client_id.toLowerCase()}}}`;
    const hash = HmacSHA256(stringToSign, secret_key);
    const enc_data = Base64.stringify(hash);

    let obj = {
        enc_data,
        Timestamp,
        Client_id,
    };

    if (credentials) {
        obj.withCredentials = credentials;
    }

    return obj;
}

export default generate;
